<template>
    <!-- Lista flotante de los desplegables y del menú "Mover a…". Una sola para
         toda la pantalla, montada en la raíz del CRM: dentro de las columnas o la
         planilla (backdrop-filter / overflow) quedaría recortada.
         cfg: { anchor, titulo, items[{v,t,html,sub,sep,ic}], val, buscar, w, onPick } -->
    <div v-if="cfg" ref="pop" class="cr-pop" :class="{ 'cr-pop--dd': !cfg.menu }" :style="estilo" role="presentation"
         @keydown="tecla" @mousedown.stop>
        <h4 v-if="cfg.titulo">{{ cfg.titulo }}</h4>
        <label v-if="conBuscador" class="cr-pop-search">
            <span v-html="I.search"></span>
            <input ref="q" v-model="q" type="text" :placeholder="T.dd.search" :aria-label="T.dd.search" autocomplete="off" />
        </label>
        <div class="cr-pop-list" :role="cfg.menu ? 'menu' : 'listbox'" :aria-label="cfg.titulo || ''">
            <template v-for="(it, i) in visibles">
                <div v-if="it.sep" :key="'s' + i" class="cr-pop-sep"></div>
                <button v-else :key="'i' + i" type="button" class="cr-pop-item" :class="{ 'is-danger': it.danger }" :role="cfg.menu ? 'menuitem' : 'option'"
                        :aria-selected="cfg.menu ? null : String(it.v === cfg.val)" :aria-current="cfg.menu && it.actual ? 'true' : null"
                        @click="elegir(it)">
                    <span v-if="it.ic" v-html="it.ic"></span>
                    <span class="cr-pop-t"><span v-if="it.html" v-html="it.html"></span><template v-else>{{ it.t }}</template></span>
                    <span v-if="it.sub" class="cr-pop-sub">{{ it.sub }}</span>
                    <span v-if="!cfg.menu && it.v === cfg.val" class="cr-pop-check" v-html="I.check"></span>
                </button>
            </template>
            <p v-if="!visibles.length" class="cr-pop-none">{{ T.dd.none }}</p>
        </div>
    </div>
</template>

<script>
import { I, norm } from './crmUtil';
import T from './textos';

export default {
    name: 'CrmPop',
    data() { return { I, T, cfg: null, q: '', pos: { left: 0, top: 0, maxHeight: 400, width: 240 } }; },
    computed: {
        conBuscador() { return !!(this.cfg && this.cfg.buscar && this.cfg.items.length > 7); },
        visibles() {
            if (!this.cfg) return [];
            const q = norm(this.q);
            return q ? this.cfg.items.filter(it => !it.sep && norm(it.t).includes(q)) : this.cfg.items;
        },
        estilo() { return { left: this.pos.left + 'px', top: this.pos.top + 'px', maxHeight: this.pos.maxHeight + 'px', width: this.pos.width + 'px' }; },
    },
    mounted() {
        this._afuera = e => { if (this.cfg && !this.$el.contains(e.target) && !this.cfg.anchor.contains(e.target)) this.cerrar(false); };
        this._mover = () => { if (this.cfg) this.cerrar(false); };
        document.addEventListener('mousedown', this._afuera, true);
        window.addEventListener('resize', this._mover);
        window.addEventListener('scroll', this._onScroll = e => { if (this.cfg && !(this.$el.contains && this.$el.contains(e.target))) this.cerrar(false); }, true);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this._afuera, true);
        window.removeEventListener('resize', this._mover);
        window.removeEventListener('scroll', this._onScroll, true);
    },
    methods: {
        abierto(anchor) { return !!(this.cfg && this.cfg.anchor === anchor); },
        abrir(cfg) {
            if (this.cfg) this.cerrar(false);
            this.q = '';
            this.cfg = cfg;
            cfg.anchor.setAttribute('aria-expanded', 'true');
            this.$nextTick(() => {
                const p = this.$refs.pop, r = cfg.anchor.getBoundingClientRect();
                const w = Math.min(Math.max(r.width, cfg.w || 230), innerWidth - 16);
                this.pos.width = w;
                const alto = p.scrollHeight, abajo = innerHeight - r.bottom - 12, arriba = r.top - 12;
                const max = Math.max(160, Math.min(alto, Math.max(abajo, arriba)));
                this.pos.maxHeight = max;
                this.pos.left = Math.max(8, Math.min(cfg.alinear === 'derecha' ? r.right - w : r.left, innerWidth - w - 8));
                this.pos.top = abajo >= Math.min(alto, max) || abajo >= arriba ? r.bottom + 6 : r.top - Math.min(alto, max) - 6;
                this.$nextTick(() => {
                    const sel = p.querySelector('.cr-pop-item[aria-selected="true"]');
                    if (sel) sel.scrollIntoView({ block: 'nearest' });
                    (this.$refs.q || p.querySelector('.cr-pop-item:not([aria-current])') || sel || p.querySelector('.cr-pop-item') || p).focus();
                });
            });
        },
        cerrar(devolverFoco = true) {
            if (!this.cfg) return;
            const a = this.cfg.anchor;
            a.setAttribute('aria-expanded', 'false');
            this.cfg = null;
            if (devolverFoco && a.isConnected) a.focus();
        },
        elegir(it) {
            const { onPick, val, menu, anchor } = this.cfg;
            this.cerrar(false);
            if (menu || it.v !== val) onPick(it.v);
            this.$nextTick(() => { if (anchor.isConnected) anchor.focus(); });
        },
        tecla(e) {
            const its = [...this.$refs.pop.querySelectorAll('.cr-pop-item')], i = its.indexOf(document.activeElement);
            if (e.key === 'ArrowDown') { e.preventDefault(); if (its.length) its[(i + 1) % its.length].focus(); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); if (its.length) its[i <= 0 ? its.length - 1 : i - 1].focus(); }
            else if (e.key === 'Enter' && e.target === this.$refs.q) { e.preventDefault(); const v = this.visibles.filter(x => !x.sep); if (v[0]) this.elegir(v[0]); }
            else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.cerrar(true); }
            else if (e.key === 'Tab') { this.cerrar(true); }
        },
    },
};
</script>
